<div class="home">
  <div class="htv-page-content" [innerHTML]="pageHtml"></div>
  <app-nav-bar [menus]="menus" (buttonClicked)="onNavButtonClick($event)"></app-nav-bar>
  <ng-container #vcr></ng-container>
</div>
